/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * 

 * Generated by orval 🍺
 * Do not edit manually.
 * OpenAPI spec version: 0.0.0 (v7)
 */
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';

import type { ErrorType } from '../../modules/Network/orvalHTTPInterface';
import { HTTP } from '../../modules/Network/orvalHTTPInterface';

import type { ApiPersonPublicCalendarRetrieveParams } from './model/apiPersonPublicCalendarRetrieveParams';
import type { PersonCalendar } from './model/personCalendar';

/**
 * Base class for all the Person subresource views that need a person PK
in the URL kwargs
 */
export const apiPersonPublicCalendarRetrieve = (
  opk: string,
  params?: ApiPersonPublicCalendarRetrieveParams,
  signal?: AbortSignal
) => {
  return HTTP<PersonCalendar>({
    url: `/api/v7/people/${opk}/public-calendar/`,
    method: 'GET',
    params,
    signal,
  });
};

export const getApiPersonPublicCalendarRetrieveQueryKey = (
  opk?: string,
  params?: ApiPersonPublicCalendarRetrieveParams
) => {
  return [`/api/v7/people/${opk}/public-calendar/`, ...(params ? [params] : [])] as const;
};

export const getApiPersonPublicCalendarRetrieveQueryOptions = <
  TData = Awaited<ReturnType<typeof apiPersonPublicCalendarRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonPublicCalendarRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonPublicCalendarRetrieve>>,
      TError,
      TData
    >;
  }
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getApiPersonPublicCalendarRetrieveQueryKey(opk, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof apiPersonPublicCalendarRetrieve>>> = ({
    signal,
  }) => apiPersonPublicCalendarRetrieve(opk, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!opk,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof apiPersonPublicCalendarRetrieve>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type ApiPersonPublicCalendarRetrieveQueryResult = NonNullable<
  Awaited<ReturnType<typeof apiPersonPublicCalendarRetrieve>>
>;
export type ApiPersonPublicCalendarRetrieveQueryError = ErrorType<unknown>;

export function useApiPersonPublicCalendarRetrieve<
  TData = Awaited<ReturnType<typeof apiPersonPublicCalendarRetrieve>>,
  TError = ErrorType<unknown>
>(
  opk: string,
  params?: ApiPersonPublicCalendarRetrieveParams,
  options?: {
    query?: UseQueryOptions<
      Awaited<ReturnType<typeof apiPersonPublicCalendarRetrieve>>,
      TError,
      TData
    >;
  }
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getApiPersonPublicCalendarRetrieveQueryOptions(opk, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
}
